// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UTcs","actions":"styles_actions__1kG5v","error":"styles_error__2Etay","message":"styles_message__TItDh"};